import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-bomb-visual',
  template: `
    <div class="bomb-wrapper" [class.exploding]="isExploding" [class.ticking]="!isExploding">
      <div class="bomb-body">
        <svg class="bomb-svg" viewBox="0 0 64 64" width="72" height="72">
          <circle cx="32" cy="38" r="22" fill="#2D2D2D"/>
          <circle cx="32" cy="38" r="20" fill="#3A3A3A"/>
          <ellipse cx="26" cy="32" rx="6" ry="4" fill="rgba(255,255,255,0.08)" transform="rotate(-20 26 32)"/>
          <rect x="28" y="10" width="8" height="12" rx="3" fill="#555"/>
          <line x1="32" y1="10" x2="36" y2="2" stroke="#FFA000" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="36" cy="2" r="3" fill="#FF9800" opacity="0.9"/>
          <circle cx="37" cy="1" r="2" fill="#FFC107"/>
        </svg>
        <div class="fuse-sparks" *ngIf="!isExploding">
          <svg class="spark" *ngFor="let s of [1,2,3]" width="14" height="14" viewBox="0 0 14 14">
            <path d="M7 0L8.5 5L14 7L8.5 9L7 14L5.5 9L0 7L5.5 5Z" fill="#FFC107"/>
          </svg>
        </div>
      </div>
      <div class="bomb-timer" *ngIf="!isExploding">{{ timeLeft | arabicNumber:currLang }}{{ currLang === 'ar' ? 'ث' : 's' }}</div>
      <div class="explosion" *ngIf="isExploding">
        <span class="boom-text">{{ currLang === 'ar' ? 'بوم!' : 'BOOM!' }}</span>
        <div class="explosion-ring"></div>
        <div class="explosion-ring ring-2"></div>
      </div>
    </div>
  `,
  styles: [`
    .bomb-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: calc(8px * var(--game-scale, 1));
      position: relative;
    }
    .bomb-body {
      position: relative;
      line-height: 1;
      transition: transform 0.1s;
    }
    .bomb-wrapper.ticking .bomb-body {
      animation: bombShake 0.3s ease-in-out infinite;
    }
    .fuse-sparks {
      position: absolute;
      top: -8px;
      right: -4px;
    }
    .spark {
      position: absolute;
      animation: sparkle 0.6s ease-in-out infinite;
    }
    .spark:nth-child(2) { top: -6px; left: 8px; animation-delay: 0.2s; }
    .spark:nth-child(3) { top: 4px; left: -4px; animation-delay: 0.4s; }
    .bomb-timer {
      font-size: calc(24px * var(--game-scale, 1));
      font-weight: 900;
      color: #F44336;
      text-shadow: 0 0 8px rgba(244,67,54,0.5);
    }
    .explosion {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .boom-text {
      font-size: calc(48px * var(--game-scale, 1));
      font-weight: 900;
      color: #FF9800;
      text-shadow: 0 0 20px rgba(255,152,0,0.8);
      animation: boomPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    .explosion-ring {
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(40px * var(--game-scale, 1));
      height: calc(40px * var(--game-scale, 1));
      margin: calc(-20px * var(--game-scale, 1)) 0 0 calc(-20px * var(--game-scale, 1));
      border-radius: 50%;
      border: 3px solid #FF9800;
      animation: explodeRing 0.8s ease-out forwards;
    }
    .ring-2 {
      animation-delay: 0.15s;
      border-color: #F44336;
    }
    @keyframes bombShake {
      0%, 100% { transform: rotate(-2deg); }
      50% { transform: rotate(2deg); }
    }
    @keyframes sparkle {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.3; transform: scale(0.5); }
    }
    @keyframes boomPop {
      0% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1.3); }
      100% { transform: scale(1); opacity: 1; }
    }
    @keyframes explodeRing {
      0% { transform: scale(1); opacity: 1; }
      100% { transform: scale(6); opacity: 0; }
    }
    .bomb-wrapper.exploding .bomb-body {
      animation: explodeBomb 0.3s ease-out forwards;
    }
    @keyframes explodeBomb {
      0% { transform: scale(1); opacity: 1; }
      100% { transform: scale(2); opacity: 0; }
    }
  `]
})
export class BombVisualComponent {
  @Input() timeLeft = 10;
  @Input() isExploding = false;
  @Input() currLang: any = 'en';
}
